import { BehaviorSubject, distinctUntilChanged, map, of, switchMap } from 'rxjs'

const parallaxPos$ = new BehaviorSubject(0)

export const setParallaxPos = (value: number): void => {
  parallaxPos$.next(value)
}

const parallaxEnabled$ = new BehaviorSubject(false)

export const setParallaxEnabled = (value: boolean): void => {
  parallaxEnabled$.next(value)
}

export const desktopMenuWrapperTop$ = parallaxEnabled$.pipe(
  switchMap((parallaxEnabled) =>
    parallaxEnabled
      ? parallaxPos$.pipe(
          map((parallaxPos) => Math.max(-60, parallaxPos)),
          distinctUntilChanged(),
        )
      : of(0),
  ),
)

// offset of main menu container from desktop menu wrapper (i.e. height of utility nav)
const utilityNavHeight = 47
// relative to container rendered below utility menu (additional 1px for visual centering)
export const mainMenuInitialTop = 25
// additional margin between utility menu and main menu
const mainMenuMarginTop = 11

export const mainMenuTop$ = desktopMenuWrapperTop$.pipe(
  map((menuWrapperTop) => {
    const clipAmount = Math.abs(Math.min(0, menuWrapperTop + utilityNavHeight + mainMenuMarginTop))
    return mainMenuInitialTop + clipAmount / 2
  }),
  distinctUntilChanged(),
)
